<script>
import NavBar from '@components/nav-bar.vue'
import SignOut from '@components/sign-out.vue'
import AppSwitcher from '@components/app-stream/app-switcher.vue'
import { getHardwareId } from '@utils/hardware'
import { httpServices } from '@utils/http-services'

export default {
  components: { AppSwitcher, NavBar, SignOut },
  data() {
    return {
      hardwareId: getHardwareId(this.$route.fullPath),
      containers: null,
    }
  },
  mounted() {
    httpServices.getFleetStatus().then((fleetStatus) => {
      httpServices.getContainers().then((res) => {
        const containers = res.filter(
          (i) => i.hardwareId.toLowerCase() === this.hardwareId.toLowerCase()
        )
        containers.forEach((c) => {
          const state = fleetStatus?.filter(
            (f) => f?.bonfireId === c?.bonfireId
          )
          c.state = state[0]?.State
        })
        if (this.$auth.user.profile.permissions.role !== 'admin') {
          httpServices.getGroups().then((groups) => {
            this.containers = this.filterContainers(containers, groups)
          })
        } else {
          this.containers = containers
        }
        if (this.containers?.length) {
          this.containers.sort((a, b) => (a.name > b.name ? 1 : -1))
        }
      })
    })
  },
  methods: {
    filterContainers(containers, groups) {
      const userGroups = groups
        .filter((i) =>
          i.meta?.userId?.includes('USER#' + this.$auth.user.email)
        )
        .map(({ pk }) => pk)
      const cArr = containers.filter((c) => {
        const email = this.$auth.user.email
        if (c?.meta?.userId && c.meta.userId.includes(email)) {
          return c
        }
        const found = c?.meta?.groupId.some((r) => userGroups.includes(r))
        if (found) {
          return c
        }
      })
      return cArr
    },
    onCollapse(collapsed, type) {},
    onBreakpoint(broken) {},
  },
}
</script>

<template>
  <a-layout id="components-layout-demo-responsive">
    <a-layout-sider
      breakpoint="lg"
      collapsed-width="0"
      :collapsible="true"
      @collapse="onCollapse"
      @breakpoint="onBreakpoint"
    >
      <div class="logo" />
      <NavBar v-if="$auth.isAuthenticated && $auth.user.profile" />
      <div class="sign-out--container">
        <SignOut />
      </div>
    </a-layout-sider>
    <a-layout>
      <a-layout-header
        :style="{
          height: '6rem',
          background: '#fff',
          overflow: 'hidden',
        }"
      >
        <div
          class="app-switcher--container"
          :style="{
            justifyContent:
              containers && !containers.length ? 'center' : undefined,
          }"
        >
          <div v-if="containers">
            <AppSwitcher
              :containers="containers"
              :style="{ padding: '24px' }"
            />
          </div>
          <div v-else style="width: 100%; text-align: center">
            <a-icon
              type="loading"
              style="font-size: 24px; color: #1890ff"
              spin
            />
          </div>
        </div>
      </a-layout-header>
      <a-layout-content style="min-height: 0; margin: 24px">
        <slot />
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<style lang="scss">
@import '@design';
.app-switcher--container {
  display: flex;
  width: 100%;
  padding: 16px 0;
  overflow-x: scroll;
}
</style>
